var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 6,
    fill: "#F8F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(6.66602 6.66699)",
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.041 11.917C11.916 11.917 11.916 12.229 11.916 16.042V16.0795C11.916 17.74 11.916 18.94 12.3225 19.447C12.72 19.939 13.9005 20.167 16.041 20.167C18.1815 20.167 19.362 19.9375 19.7595 19.4455C20.166 18.94 20.166 17.74 20.166 16.078C20.166 12.229 20.166 11.917 16.041 11.917ZM16.041 22.417C13.512 22.417 11.6145 22.1515 10.572 20.857C9.66602 19.7335 9.66602 18.2005 9.66602 16.0795L10.791 16.042H9.66602C9.66602 11.737 9.93752 9.66699 16.041 9.66699C22.1445 9.66699 22.416 11.737 22.416 16.042C22.416 18.199 22.416 19.7335 21.51 20.857C20.4675 22.1515 18.57 22.417 16.041 22.417Z",
    fill: "#848FA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.541 11.917C28.416 11.917 28.416 12.229 28.416 16.042V16.0795C28.416 17.74 28.416 18.94 28.8225 19.447C29.22 19.939 30.4005 20.167 32.541 20.167C34.6815 20.167 35.862 19.9375 36.2595 19.4455C36.666 18.94 36.666 17.74 36.666 16.078C36.666 12.229 36.666 11.917 32.541 11.917ZM32.541 22.417C30.012 22.417 28.1145 22.1515 27.072 20.857C26.166 19.7335 26.166 18.2005 26.166 16.0795L27.291 16.042H26.166C26.166 11.737 26.4375 9.66699 32.541 9.66699C38.6445 9.66699 38.916 11.737 38.916 16.042C38.916 18.199 38.916 19.7335 38.01 20.857C36.9675 22.1515 35.07 22.417 32.541 22.417Z",
    fill: "#848FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.041 28.417C11.916 28.417 11.916 28.729 11.916 32.542V32.5795C11.916 34.24 11.916 35.44 12.3225 35.947C12.72 36.439 13.9005 36.667 16.041 36.667C18.1815 36.667 19.362 36.4375 19.7595 35.9455C20.166 35.44 20.166 34.24 20.166 32.578C20.166 28.729 20.166 28.417 16.041 28.417ZM16.041 38.917C13.512 38.917 11.6145 38.6515 10.572 37.357C9.66602 36.2335 9.66602 34.7005 9.66602 32.5795L10.791 32.542H9.66602C9.66602 28.237 9.93752 26.167 16.041 26.167C22.1445 26.167 22.416 28.237 22.416 32.542C22.416 34.699 22.416 36.2335 21.51 37.357C20.4675 38.6515 18.57 38.917 16.041 38.917Z",
    fill: "#848FA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.541 28.417C28.416 28.417 28.416 28.729 28.416 32.542V32.5795C28.416 34.24 28.416 35.44 28.8225 35.947C29.22 36.439 30.4005 36.667 32.541 36.667C34.6815 36.667 35.862 36.4375 36.2595 35.9455C36.666 35.44 36.666 34.24 36.666 32.578C36.666 28.729 36.666 28.417 32.541 28.417ZM32.541 38.917C30.012 38.917 28.1145 38.6515 27.072 37.357C26.166 36.2335 26.166 34.7005 26.166 32.5795L27.291 32.542H26.166C26.166 28.237 26.4375 26.167 32.541 26.167C38.6445 26.167 38.916 28.237 38.916 32.542C38.916 34.699 38.916 36.2335 38.01 37.357C36.9675 38.6515 35.07 38.917 32.541 38.917Z",
    fill: "#848FA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.546c5e35ca95e190ec4130941ea199fc.svg";
export { ForwardRef as ReactComponent };